import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

class ScansRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('scans.list');
  }
}

export default instrumentRoutePerformance(ScansRoute);
